import { SuccessCircleIcon } from '@/common/icons/general'
import { Button } from '@/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentAccount } from '@/storage/applications/reimubrusementAccountSlice'
import { RootState } from '@/storage/store.ts'

const aceSupportEmail = "support@acescholarships.org"

export const ReimbursementAccountLinked = () => {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()
  const dispatch = useDispatch()

  const programSettings = useSelector((state: RootState) => state.ProgramSettings)

  const showEmailByProgram = () => {
    return aceSupportEmail;
  }

  return (
    <>
      <div className="flex flex-col items-center justify-center mt-6 min-h-[40vh]">
        <SuccessCircleIcon />
        <h3 className="text-xl font-medium text-gray-900 mt-3">
          {translate('bank_account_linked', { 'program': programSettings?.data?.name })}
        </h3>
        <p className="text-sm font-medium text-gray-900 mt-6">
          If your organization requires approval, once your program administrator approves your reimbursement,
          the requested funds will be transferred via ACH into the linked account.
        </p>
        <p className="text-sm text-center text-gray-900 mt-6">
          For more information or assistance, contact us at {showEmailByProgram()} Or by phone at +1 (985) 800-3950
        </p>
      </div>
      <div className="text-center h-full flex mt-6">
        <div className="flex justify-end mb-5 w-full flex-col">
          <Button
            onClick={() => {
              dispatch(setCurrentAccount(null));
              navigateTo(AppRoutePaths.reimbursements.accounts.index)
            }}
            className="rounded h-9 mb-5"
          >
            {translate('go_to_homepage')}
          </Button>
        </div>
      </div>
    </>
  )
}
